export const LANGS = [
  { code: "en", flag: "/flags/ca.png", label: "ENGLISH" },
  { code: "es", flag: "/flags/mx.png", label: "ESPAÑOL" },
  { code: "fr", flag: "/flags/fr.png", label: "FRANÇAIS" },
  { code: "pt", flag: "/flags/br.png", label: "PORTUGUÊS" },
];

export const ARTIST_TYPES = {
  en: ["Singer", "Rapper", "Musician", "Producer", "Band / Group", "Performer", "Other"],
  es: ["Cantante", "Rapper", "Músico", "Productor", "Banda / Grupo", "Performer", "Otro"],
  fr: ["Chanteur·se", "Rappeur·se", "Musicien·ne", "Producteur·rice", "Band / Groupe", "Performer", "Autre"],
  pt: ["Cantor(a)", "Rapper", "Músico", "Produtor", "Banda / Grupo", "Performer", "Outro"],
};

export const COMMITMENT_OPTIONS = {
  en: ["YES — I'M READY", "MAYBE — I'D LIKE TO LEARN MORE", "NOT RIGHT NOW"],
  es: ["SÍ — ESTOY LISTO/A", "TAL VEZ — QUIERO SABER MÁS", "AHORA NO"],
  fr: ["OUI — JE SUIS PRÊT(E)", "PEUT-ÊTRE — JE VEUX EN SAVOIR PLUS", "PAS POUR LE MOMENT"],
  pt: ["SIM — ESTOU PRONTO(A)", "TALVEZ — QUERO SABER MAIS", "AGORA NÃO"],
};

export const T = {
  en: {
    discovery: "CANARTS ARTIST DISCOVERY",
    langTitle: "YOUR TALENT. YOUR LANGUAGE.",
    langSub: "Talent speaks every language. Choose the language you're most comfortable using.",
    langFooter: "YOUR LANGUAGE IS NOT A BARRIER. YOUR TALENT IS WHAT MATTERS.",
    step1: "ABOUT YOU",
    step2: "SHOW US YOUR TALENT",
    step3: "LET'S TALK ABOUT YOUR FUTURE",
    stageName: "Artist / Stage Name",
    fullName: "Full Name",
    email: "Email",
    phone: "Phone",
    city: "City",
    age: "Age",
    artistType: "Artist Type",
    optional: "Optional",
    bestLink: "BEST MUSIC / PERFORMANCE LINK",
    bestLinkHint: "Send us ONE link that best represents you.",
    additionalLink: "ADDITIONAL LINK",
    socialTitle: "SOCIAL LINKS",
    q1: "WHY DO YOU WANT TO GROW AS AN ARTIST?",
    q2: "IF OUR TEAM GIVES YOU HONEST FEEDBACK OR ASKS YOU TO CHANGE SOMETHING TO HELP YOU GROW, HOW WOULD YOU APPROACH IT?",
    q3: "ARE YOU READY TO COMMIT TIME TO YOUR DEVELOPMENT OVER THE NEXT 12 MONTHS?",
    shortAnswer: "Short answer.",
    oppTitle: "YOU BRING THE TALENT. WE'LL HELP YOU BUILD WHAT COMES NEXT.",
    oppBody: "Selected artists may have opportunities to perform at Canarts events and participate in the Canarts artist development process.",
    back: "BACK",
    continue: "CONTINUE",
    submit: "SUBMIT YOUR AUDITION",
    submitting: "SUBMITTING...",
    errRequired: "Please complete the required fields.",
    errEmail: "Please enter a valid email.",
    errLink: "Please add your best link.",
    errSubmit: "Something went wrong. Please try again.",
    errDuplicate: "We already received an application for this email.",
    dupTitle: "APPLICATION ALREADY RECEIVED",
    dupBody: "It looks like you've already submitted an application with this email address. Our team already has your audition.",
    successTitle: "YOUR APPLICATION IS IN.",
    successBody1: "Thanks for showing us what you've got.",
    successBody2: "Our team will review your submission and selected artists will be contacted about the next step.",
    successFooter1: "KEEP CREATING.",
    successFooter2: "THIS COULD BE THE BEGINNING.",
    done: "DONE",
    confirmTitle: "Leave your application?",
    confirmBody: "Your answers will be lost.",
    confirmKeep: "Keep editing",
    confirmDiscard: "Yes, close",
  },
  es: {
    discovery: "CANARTS ARTIST DISCOVERY",
    langTitle: "TU TALENTO. TU IDIOMA.",
    langSub: "El talento habla todos los idiomas. Elige el idioma con el que te sientas más cómodo.",
    langFooter: "TU IDIOMA NO ES UNA BARRERA. TU TALENTO ES LO QUE IMPORTA.",
    step1: "SOBRE TI",
    step2: "MUÉSTRANOS TU TALENTO",
    step3: "HABLEMOS DE TU FUTURO",
    stageName: "Nombre artístico",
    fullName: "Nombre completo",
    email: "Correo electrónico",
    phone: "Teléfono",
    city: "Ciudad",
    age: "Edad",
    artistType: "Tipo de artista",
    optional: "Opcional",
    bestLink: "ENLACE DE TU MEJOR MÚSICA / PRESENTACIÓN",
    bestLinkHint: "Envíanos UN enlace que te represente mejor.",
    additionalLink: "ENLACE ADICIONAL",
    socialTitle: "REDES SOCIALES",
    q1: "¿POR QUÉ QUIERES CRECER COMO ARTISTA?",
    q2: "SI NUESTRO EQUIPO TE DA UNA OPINIÓN HONESTA O TE PIDE CAMBIAR ALGO PARA AYUDARTE A CRECER, ¿CÓMO LO TOMARÍAS?",
    q3: "¿ESTÁS LISTO/A PARA DEDICAR TIEMPO A TU DESARROLLO DURANTE LOS PRÓXIMOS 12 MESES?",
    shortAnswer: "Respuesta corta.",
    oppTitle: "TÚ PONES EL TALENTO. TE AYUDAMOS A CONSTRUIR LO QUE VIENE.",
    oppBody: "Los artistas seleccionados podrían tener la oportunidad de presentarse en eventos de Canarts y participar en el proceso de desarrollo artístico de Canarts.",
    back: "ATRÁS",
    continue: "CONTINUAR",
    submit: "ENVÍA TU AUDICIÓN",
    submitting: "ENVIANDO...",
    errRequired: "Completa los campos obligatorios.",
    errEmail: "Ingresa un correo válido.",
    errLink: "Agrega tu mejor enlace.",
    errSubmit: "Algo salió mal. Inténtalo de nuevo.",
    errDuplicate: "Ya recibimos una solicitud con este correo.",
    dupTitle: "SOLICITUD YA RECIBIDA",
    dupBody: "Parece que ya enviaste una solicitud con este correo. Nuestro equipo ya tiene tu audición.",
    successTitle: "TU SOLICITUD ESTÁ ADENTRO.",
    successBody1: "Gracias por mostrarnos lo que tienes.",
    successBody2: "Nuestro equipo revisará tu solicitud y los artistas seleccionados serán contactados sobre el siguiente paso.",
    successFooter1: "SIGUE CREANDO.",
    successFooter2: "ESTO PODRÍA SER EL COMIENZO.",
    done: "LISTO",
    confirmTitle: "¿Salir de tu solicitud?",
    confirmBody: "Tus respuestas se perderán.",
    confirmKeep: "Seguir editando",
    confirmDiscard: "Sí, cerrar",
  },
  fr: {
    discovery: "CANARTS ARTIST DISCOVERY",
    langTitle: "TON TALENT. TA LANGUE.",
    langSub: "Le talent parle toutes les langues. Choisis la langue avec laquelle tu es le plus à l'aise.",
    langFooter: "TA LANGUE N'EST PAS UNE BARRIÈRE. C'EST TON TALENT QUI COMPTE.",
    step1: "À PROPOS DE TOI",
    step2: "MONTRE-NOUS TON TALENT",
    step3: "PARLONS DE TON AVENIR",
    stageName: "Nom d'artiste / de scène",
    fullName: "Nom complet",
    email: "E-mail",
    phone: "Téléphone",
    city: "Ville",
    age: "Âge",
    artistType: "Type d'artiste",
    optional: "Optionnel",
    bestLink: "LIEN DE TA MEILLEURE MUSIQUE / PERFORMANCE",
    bestLinkHint: "Envoie-nous UN lien qui te représente le mieux.",
    additionalLink: "LIEN SUPPLÉMENTAIRE",
    socialTitle: "RÉSEAUX SOCIAUX",
    q1: "POURQUOI VEUX-TU GRANDIR EN TANT QU'ARTISTE ?",
    q2: "SI NOTRE ÉQUIPE TE DONNE UN AVIS HONNÊTE OU TE DEMANDE DE CHANGER QUELQUE CHOSE POUR T'AIDER À GRANDIR, COMMENT L'ABORDERAIS-TU ?",
    q3: "ES-TU PRÊT(E) À CONSACRER DU TEMPS À TON DÉVELOPPEMENT PENDANT LES 12 PROCHAINS MOIS ?",
    shortAnswer: "Réponse courte.",
    oppTitle: "TU APPORTES LE TALENT. ON T'AIDE À CONSTRUIRE LA SUITE.",
    oppBody: "Les artistes sélectionnés pourront avoir l'opportunité de se produire lors d'événements Canarts et de participer au processus de développement artistique de Canarts.",
    back: "RETOUR",
    continue: "CONTINUER",
    submit: "ENVOIE TON AUDITION",
    submitting: "ENVOI...",
    errRequired: "Merci de remplir les champs obligatoires.",
    errEmail: "Entre un e-mail valide.",
    errLink: "Ajoute ton meilleur lien.",
    errSubmit: "Une erreur est survenue. Réessaie.",
    errDuplicate: "Nous avons déjà reçu une candidature pour cet e-mail.",
    dupTitle: "CANDIDATURE DÉJÀ REÇUE",
    dupBody: "Il semble que tu aies déjà soumis une candidature avec cet e-mail. Notre équipe a déjà ton audition.",
    successTitle: "TA CANDIDATURE EST REÇUE.",
    successBody1: "Merci de nous avoir montré ce que tu as.",
    successBody2: "Notre équipe va étudier ta candidature et les artistes sélectionnés seront contactés pour la suite.",
    successFooter1: "CONTINUE DE CRÉER.",
    successFooter2: "CECI POURRAIT ÊTRE LE DÉBUT.",
    done: "TERMINÉ",
    confirmTitle: "Quitter ta candidature ?",
    confirmBody: "Tes réponses seront perdues.",
    confirmKeep: "Continuer l'édition",
    confirmDiscard: "Oui, fermer",
  },
  pt: {
    discovery: "CANARTS ARTIST DISCOVERY",
    langTitle: "SEU TALENTO. SEU IDIOMA.",
    langSub: "O talento fala todos os idiomas. Escolha o idioma com o qual você se sente mais confortável.",
    langFooter: "SEU IDIOMA NÃO É UMA BARREIRA. O QUE IMPORTA É O SEU TALENTO.",
    step1: "SOBRE VOCÊ",
    step2: "MOSTRE SEU TALENTO",
    step3: "VAMOS FALAR DO SEU FUTURO",
    stageName: "Nome artístico",
    fullName: "Nome completo",
    email: "E-mail",
    phone: "Telefone",
    city: "Cidade",
    age: "Idade",
    artistType: "Tipo de artista",
    optional: "Opcional",
    bestLink: "LINK DA SUA MELHOR MÚSICA / PERFORMANCE",
    bestLinkHint: "Envie UM link que melhor representa você.",
    additionalLink: "LINK ADICIONAL",
    socialTitle: "REDES SOCIAIS",
    q1: "POR QUE VOCÊ QUER CRESCER COMO ARTISTA?",
    q2: "SE NOSSA EQUIPE DER UM FEEDBACK HONESTO OU PEDIR PARA VOCÊ MUDAR ALGO PARA AJUDAR NO SEU CRESCIMENTO, COMO VOCÊ LIDARIA COM ISSO?",
    q3: "VOCÊ ESTÁ PRONTO(A) PARA DEDICAR TEMPO AO SEU DESENVOLVIMENTO NOS PRÓXIMOS 12 MESES?",
    shortAnswer: "Resposta curta.",
    oppTitle: "VOCÊ TRAZ O TALENTO. NÓS AJUDAMOS A CONSTRUIR O QUE VEM DEPOIS.",
    oppBody: "Artistas selecionados poderão ter oportunidades de se apresentar em eventos da Canarts e participar do processo de desenvolvimento artístico da Canarts.",
    back: "VOLTAR",
    continue: "CONTINUAR",
    submit: "ENVIE SUA AUDIÇÃO",
    submitting: "ENVIANDO...",
    errRequired: "Preencha os campos obrigatórios.",
    errEmail: "Digite um e-mail válido.",
    errLink: "Adicione seu melhor link.",
    errSubmit: "Algo deu errado. Tente novamente.",
    errDuplicate: "Já recebemos uma inscrição com este e-mail.",
    dupTitle: "INSCRIÇÃO JÁ RECEBIDA",
    dupBody: "Parece que você já enviou uma inscrição com este e-mail. Nossa equipe já tem sua audição.",
    successTitle: "SUA INSCRIÇÃO FOI ENVIADA.",
    successBody1: "Obrigado por nos mostrar o que você tem.",
    successBody2: "Nossa equipe vai analisar sua inscrição e os artistas selecionados serão contatados sobre o próximo passo.",
    successFooter1: "CONTINUE CRIANDO.",
    successFooter2: "ISSO PODE SER O COMEÇO.",
    done: "CONCLUÍDO",
    confirmTitle: "Sair da sua inscrição?",
    confirmBody: "Suas respostas serão perdidas.",
    confirmKeep: "Continuar editando",
    confirmDiscard: "Sim, fechar",
  },
};
